<template>
<div class="chapter">
<div class="inner_page">
<img alt="image" class="cover" src="images/cover.jpg"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00_Cover.vue?6d8f3e60